export const experienceData = [
  {
        id: 1,
        company: 'Epitech Bénin',
        jobtitle: 'Développement Fullstack',
        startYear: 'Juillet 2025',
        endYear: 'Aujourd’hui',
    },
    {
        id: 2,
        company: 'Solutech Universe Akpakpa',
        jobtitle: 'Design Graphique',
        startYear: 'Janvier 2025',
        endYear: 'Juin 2025',
    },
    {
        id: 3,
        company: 'Solutech Universe Akpakpa',
        jobtitle: 'Stage académique Fullstack',
        startYear: 'Mars 2024',
        endYear: 'Juin 2024',
    },
    {
        id: 4,
        company: 'DRWINTECH HOUEHIYO',
        jobtitle: 'Stage académique Fullstack',
        startYear: 'Mai 2023',
        endYear: 'Juillet 2023',
    },
]
